import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class TemplateSectionListParser implements Parser {
	parse(
		schema: Record<
			string,
			Schema.Template | Schema.ListTemplate | Schema.PaginatedDataTemplate
		>,
	) {
		const names: Array<string> = [];

		for (const name in schema) {
			const templateSchema = schema[name];
			const sectionNames = templateSchema.content
				.filter((field) => field.type === "ComponentArray")
				.map(({ key }) => `"${key}"`)
				.filter(Boolean);
			const sectionNameProp =
				sectionNames && sectionNames?.length > 0
					? `${templateSchema.component}?: NonEmptyArray<${sectionNames.join("|")}>;`
					: "";

			names.push(sectionNameProp);
		}

		return `
			export type SectionList = { ${names.join("")} }
		`;
	}
}
